import Code from './Code.vue'
import ObjectPreview from './ObjectPreview.vue'
import ExpansionPanel from './ExpansionPanel.vue'
import Space from './Space.vue'
import Tooltip from './Tooltip.vue'
import TooltipContainer from './TooltipContainer.vue'

export default {
    'tl-space': Space,
    'tl-expansion-panel': ExpansionPanel,
    'tl-tooltip': Tooltip,
    'tl-tooltip-container': TooltipContainer,
    'tl-code': Code,
    'tl-object-preview': ObjectPreview,
}
